import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { fadeInUp, staggerContainer } from "@/lib/constants";

export const BlogCTASection = () => {
  return (
    <section className="relative section-padding" data-testid="blog-cta-section">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          <Card className="bg-slate-900/60 border-slate-800 hover:border-indigo-500/40 transition-all duration-500 overflow-hidden">
            <CardContent className="p-8 sm:p-12 relative">
              <div className="spotlight-2 -top-20 -right-20 opacity-30" />
              <div className="relative z-10">
                <motion.p variants={fadeInUp} className="text-indigo-400 font-medium mb-3 text-sm flex items-center gap-2">
                  <BarChart3 className="w-4 h-4" />
                  Desde nuestro blog
                </motion.p>
                <motion.h2 variants={fadeInUp} className="text-2xl sm:text-3xl font-bold mb-4 leading-tight">
                  Cómo saber si tu empresa está perdiendo dinero{" "}
                  <span className="text-gradient">(y no te estás dando cuenta)</span>
                </motion.h2>
                <motion.p variants={fadeInUp} className="text-slate-400 text-base mb-8 max-w-2xl">
                  Tu empresa puede estar perdiendo dinero sin que lo sepas. No por falta de datos, sino por no analizarlos correctamente.
                </motion.p>
                <motion.div variants={fadeInUp}>
                  <Button
                    asChild
                    className="btn-glow bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-6 text-base rounded-full"
                    data-testid="blog-cta-homepage-btn"
                  >
                    <Link to="/blog/como-saber-si-tu-empresa-pierde-dinero">
                      Leer el artículo
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Link>
                  </Button>
                </motion.div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};
